import { useContext, useId, useRef, useState } from "react";
import { ReactReduxContext } from "react-redux";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Localize } from "../../../shared/ariaLabelLocalize";
import "./InfoToggletip.scss";

const InfoToggletip = ({ text, className }) => {
    const contentId = useId();
    const wrapperRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [dismissed, setDismissed] = useState(false);
    const reduxContext = useContext(ReactReduxContext);
    const languageId = reduxContext?.store?.getState()?.language?.selectedlanguage?.id;
    const localised = Localize[languageId] || Localize["en_US"];

    const toggle = () => {
        setDismissed(open);
        setOpen(!open);
    };

    const onKeyDownCapture = (event) => {
        if (event.key !== "Escape") return;
        const showing = open || (!dismissed && wrapperRef.current?.matches(":hover"));
        if (!showing) return;
        event.stopPropagation();
        setOpen(false);
        setDismissed(true);
    };

    const reset = () => {
        setOpen(false);
        setDismissed(false);
    };

    return (
        <div ref={wrapperRef} className={clsx("custom-tooltip info-toggletip", className, dismissed && "custom-tooltip-hidden")}>
            <button
                type="button"
                className="custom-tooltip-icon"
                aria-label={localised.click_to_open_more_information}
                aria-expanded={open}
                aria-controls={contentId}
                onClick={toggle}
                onKeyDownCapture={onKeyDownCapture}
                onFocus={() => setDismissed(false)}
                onBlur={reset}
            >
                <span className="icon-info" aria-hidden="true"></span>
            </button>
            <div id={contentId} className={clsx("custom-tooltip-content", open && "is-open")} aria-hidden={!open}>
                <div className="custom-tooltip-in">
                    <p>{text}</p>
                </div>
            </div>
            <span className="visually-hidden" aria-live="polite" data-testid="infoToggletipLive">{open ? text : ""}</span>
        </div>
    );
};

InfoToggletip.propTypes = {
    text: PropTypes.string,
    className: PropTypes.string,
};

export default InfoToggletip;
